import { useState, useEffect } from "react";
import {
  useGetMilestonesQuery,
  useUpdateMilestonesMutation,
} from "../../features/api/adminApiSlice";
import FuelLoading from "../../pages/FuelLoading";
import { useToast } from "../toast/ToastContext"; // 🟢 IMPORT GLOBAL TOAST HOOK SYSTEM
import "./adminMilestones.scss";
import AdminHeader from "../layout/AdminHeader";

export default function AdminMilestones() {
  const { showToast } = useToast();

  // Fetch current numbers from the server database
  const { data: currentStats, isLoading } = useGetMilestonesQuery();
  const [updateMilestones, { isLoading: isUpdating }] =
    useUpdateMilestonesMutation();

  // Local input field states
  const [milesDriven, setMilesDriven] = useState("");
  const [nationalParks, setNationalParks] = useState("");
  const [smallTowns, setSmallTowns] = useState("");
  const [smallCar, setSmallCar] = useState("1");

  // Populate form fields as soon as database cache values resolve
  useEffect(() => {
    if (currentStats) {
      setMilesDriven(currentStats.milesDriven || "");
      setNationalParks(currentStats.nationalParks || "");
      setSmallTowns(currentStats.smallTowns || "");
      setSmallCar(currentStats.smallCar || "1");
    }
  }, [currentStats]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateMilestones({
        milesDriven: milesDriven.trim(),
        nationalParks: nationalParks.trim(),
        smallTowns: smallTowns.trim(),
        smallCar: smallCar.trim(),
      }).unwrap();

      // 🟢 REPLACED LOCAL STATE STRINGS WITH GLOBAL SUCCESS TOAST
      showToast(
        "Journey Tracker parameters updated and live across the site!",
        "success"
      );
    } catch (err) {
      // 🟢 REPLACED LOCAL STATE STRINGS WITH GLOBAL ERROR TOAST
      showToast(
        "Failed to broadcast milestone updates across state line servers.",
        "error"
      );
    }
  };

  // 🚗 FIX: Use the localized conditional overlay so the screen transitions instead of crashing the view layout completely
  if (isLoading) {
    return (
      <div className="admin-milestones-loading">
        <FuelLoading text="Recalibrating road travel metrics..." />
      </div>
    );
  }

  return (
    <div className="admin-milestones-wrapper fuel-fade-in">
      {/* 🟢 FREEZE SCREEN ONLY DURING ACTION WRITES SAVE LOOPS MUTATIONS */}
      {isUpdating && (
        <FuelLoading
          text="Broadcasting fresh telemetry logs down the line..."
          fullScreen
        />
      )}

      {/* 🟢 NEW REUSABLE CENTRAL ADVERTISING HEADER */}
      <AdminHeader
        title="Odometer & Journey Milestones Control"
        description="Update global telemetry trackers, log road trip progress metrics, and adjust total explore counts rendered across live public views."
        badgeText="Odometer Desk"
      />

      <form className="milestones-form-card" onSubmit={handleSubmit}>
        <div className="milestones-form-stack">
          <label className="milestones-input-label">
            Total Miles Driven
            <input
              type="text"
              value={milesDriven}
              onChange={(e) => setMilesDriven(e.target.value)}
              placeholder="e.g. 40k+"
              disabled={isUpdating}
              required
            />
          </label>

          <label className="milestones-input-label">
            National Parks Visited
            <input
              type="text"
              value={nationalParks}
              onChange={(e) => setNationalParks(e.target.value)}
              placeholder="e.g. 24"
              disabled={isUpdating}
              required
            />
          </label>

          <label className="milestones-input-label">
            Small Towns Explored
            <input
              type="text"
              value={smallTowns}
              onChange={(e) => setSmallTowns(e.target.value)}
              placeholder="e.g. 100+"
              disabled={isUpdating}
              required
            />
          </label>

          <label className="milestones-input-label">
            Active Small Cars
            <input
              type="text"
              value={smallCar}
              onChange={(e) => setSmallCar(e.target.value)}
              placeholder="e.g. 1"
              disabled={isUpdating}
              required
            />
          </label>
        </div>

        <button
          type="submit"
          className="fuel-primary-btn save-milestones-btn"
          disabled={isUpdating}
        >
          Broadcast New Journey Metrics
        </button>
      </form>
    </div>
  );
}
